import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';
import Box from 'components/atoms/Layout/Box/Box';

const StyledCenterWrapper = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--center-wrapper-bounds-top': props.$wrapper?.boundsCum?.top ?? '0px',
      '--center-wrapper-bounds-right': props.$wrapper?.boundsCum?.right ?? '0px',
      '--center-wrapper-bounds-bottom': props.$wrapper?.boundsCum?.bottom ?? '0px',
      '--center-wrapper-bounds-left': props.$wrapper?.boundsCum?.left ?? '0px',
      '--center-wrapper-center-width': utils.isDefined(props.$centerWidth) ? props.theme.layout(props.$centerWidth) : null
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;

  align-items: center;
  justify-content: center;

  min-height: calc(100vh - (${props => props.$css.$var('--center-wrapper-bounds-top')} + ${props => props.$css.$var('--center-wrapper-bounds-bottom')}));
  width: calc(100vw - (${props => props.$css.$var('--center-wrapper-bounds-left')} + ${props => props.$css.$var('--center-wrapper-bounds-right')}));

  > * {
    text-align: center;
  
    max-width: ${props => utils.isDefined(props.$centerWidth) ? props.$css.$var('--center-wrapper-center-width', false) : null};
    width: ${props => utils.isDefined(props.$centerWidth) ? props.theme.layout('100%') : null};
    height: unset;
    min-height: unset;
  }

  ${ComponentStyles}
`;

StyledCenterWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledCenterWrapper;
